
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Слой 1","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M120.48 6.16c-9.16-8.54-24-8.11-33 1L34.15 60.49c-2.9 2.9-4.4 7.61-6.15 13.07-2.14 6.7-4.57 14.31-10.14 19.89L15.34 96l-12 12a12.13 12.13 0 000 16.7 11.78 11.78 0 008.32 3.3 11.8 11.8 0 008.34-3.29l14.54-14.56c5.58-5.6 13.17-8 19.87-10.15 5.41-1.72 10.08-3.21 12.94-6.08l53.74-53.82a23.59 23.59 0 00-.61-33.94zM17.17 121.88a7.8 7.8 0 01-5.51 2.12 7.8 7.8 0 01-5.51-2.14 8.24 8.24 0 010-11l10.6-10.62 11 11zm101.1-84.61L64.53 91.1c-2.18 2.18-6.42 3.53-11.33 5.09-6.78 2.16-15.2 4.81-21.49 11.13l-1.11 1.11-11-11 1.11-1.11C27 90 29.65 81.56 31.81 74.77c1.59-5 2.95-9.23 5.17-11.45L90.26 10a20.33 20.33 0 0114.37-6 19.12 19.12 0 0113.12 5.08 19.59 19.59 0 01.52 28.18z"}}),_c('path',{attrs:{"d":"M97.55 13.69a2.06 2.06 0 00-2.83 0L61.48 47a2 2 0 000 2.83L78.1 66.45a2 2 0 001.42.59 2 2 0 001.41-.59l33.24-33.28a2 2 0 000-2.83zm-18 48.52L65.73 48.4l30.41-30.46 13.79 13.81zM126 128H70a2 2 0 01-1.73-3l28-48.37a2 2 0 013.46 0l28 48.37a2 2 0 01-1.73 3zm-52.53-4h49.06L98 81.63z"}}),_c('path',{attrs:{"d":"M98 121a2 2 0 01-1.41-.59 1.42 1.42 0 01-.25-.3 2.27 2.27 0 01-.19-.34 1.82 1.82 0 01-.11-.38 1.72 1.72 0 010-.39 2 2 0 01.59-1.42 2.07 2.07 0 012.82 0A2 2 0 01100 119a1.72 1.72 0 010 .39 2.72 2.72 0 01-.11.38 2.27 2.27 0 01-.19.34 1.42 1.42 0 01-.25.3A2 2 0 0198 121zm0-8a2 2 0 01-2-2V99a2 2 0 014 0v12a2 2 0 01-2 2zM30 39.2a2 2 0 00-2 2 7.64 7.64 0 01-8 7.8 7.64 7.64 0 01-8-7.8V20h6.8a2 2 0 000-4H12V2a2 2 0 00-4 0v14H2a2 2 0 000 4h6v21.2A11.64 11.64 0 0020 53a11.64 11.64 0 0012-11.8 2 2 0 00-2-2zM39 0a8 8 0 108 8 8 8 0 00-8-8zm0 12a4 4 0 114-4 4 4 0 01-4 4z"}})])
          )
        }
      }
    